import React from "react";
import QuickReportIcon from "../../../../Assets/svg/TellArnie_Clipboard_Clock_WHT 1.svg";
import StandardReportIcon from "../../../../Assets/svg/TellArnie_Clipboard_WHT 1.svg";
import NearMissIcon from "../../../../Assets/svg/TellArnie_ReportedIncidents_WHT 1.svg";
import "./index.css";
import { NavLink } from "react-router-dom";
import { usePic } from "../../../../context/PicProvider";
import InjuryTypeSelect from "./InjuryTypeSelect";
import { useDispatch } from "react-redux";
import { setInjuryType } from "../../../../redux/slice/QuickReportSlice";

const StandardWithQuickReport = () => {
  const { setSuccessPopup } = usePic();
  const dispatch = useDispatch();
  const handleIncidentReport = (title, primaryURL) => {
    dispatch(setInjuryType("single"));
    setSuccessPopup({
      open: true,
      title,
      secondaryText: "Cancel",
      primaryText: "Continue",
      message: "Please provide information specific to this incident only.",
      primaryURL,
      child: <InjuryTypeSelect />,
    });
  };

  return (
    <div className="standardwithquickreport d-flex flex-column align-items-center incident-report-container">
      <h2
        className="letter_spacing fw-bold text-center m-0"
        style={{ fontSize: "32px", color: "#359742" }}
      >
        Report an incident
      </h2>
      <div
        className="navigationcontroller d-flex flex-column row-gap-4"
        style={{ marginTop: "40px" }}
      >
        <NavLink
          // to={{
          //   pathname: "/kit-details",
          //   search: "?report-type=standard-report",
          // }}
          className={"nav-link"}
          onClick={() =>
            handleIncidentReport("Detailed Report", "detailedreportinfo")
          }
        >
          <div className="inner_box">
            <div className="image" style={{ width: "150px", height: "150px" }}>
              <img
                src={StandardReportIcon}
                alt="boximage"
                className="w-100 h-100 object-fit-contain"
              />
            </div>
            <div className="text_data">
              <h5 className="fw-bold open-sans-font">Detailed Report</h5>
              <h6 className="open-sans-font m-0">
                <span className="fw-bold title-1"> More serious? </span>
                <span className="title-2">
                  Tell Arnie about any other type of incident
                </span>
              </h6>
            </div>
          </div>
        </NavLink>
        <NavLink
          // to={{
          //   pathname: "/kit-details",
          //   search: "?report-type=quick-report",
          // }}
          className={"nav-link"}
          onClick={() =>
            handleIncidentReport("Quick Incident Report", "quickreportinfo")
          }
        >
          <div className="inner_box">
            <div className="image" style={{ width: "150px", height: "150px" }}>
              <img
                src={QuickReportIcon}
                alt="quick-report-icon"
                className="w-100 h-100 object-fit-contain"
              />
            </div>
            <div className="text_data">
              <h5 className="fw-bold open-sans-font">Quick</h5>
              <h6 className="open-sans- m-0">
                <span className="fw-bold title-1">Just used a plaster?</span>
                <br />
                <span className="title-2">
                  Tell Arnie about minor cuts strains and sprains
                </span>
              </h6>
            </div>
          </div>
        </NavLink>
        <NavLink
          to={{
            pathname: "/near-miss-report-info",
          }}
          className={"nav-link"}
        >
          <div className="inner_box">
            <div className="image" style={{ width: "150px", height: "150px" }}>
              <img
                src={NearMissIcon}
                alt="boximage"
                className="w-100 h-100 object-fit-contain"
              />
            </div>
            <div className="text_data">
              <h5 className="fw-bold open-sans-font">A Near Miss</h5>
              <h6 className="open-sans-font m-0">
                <span className="fw-bold title-1">It was avoided? </span>
                <span className="title-2">
                  Tell Arnie about hazards and prevent future incidents
                </span>
              </h6>
            </div>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default StandardWithQuickReport;
